import { parsePhoneNumber } from 'libphonenumber-js'
import { ContactCardPrefill } from '../models/contacts'
import { ContactDefaultValues } from '../components/Modals/ContactModal/ContactModal'

/**
 * Normalize a scanned phone number to E.164 (e.g. "818-822-6177" -> "+18188226177"),
 * defaulting to the US (+1) country. `PhoneInput` (react-phone-number-input) requires
 * E.164 and errors/clears on anything else, so feed it E.164 or an empty string.
 */
export function normalizePhoneToE164(raw?: string | null): string {
  if (!raw) return ''
  try {
    const parsed = parsePhoneNumber(raw, 'US')
    if (parsed?.number) return parsed.number
  } catch {
    // fall through to the digit-based fallback below
  }
  // Fallback for numbers libphonenumber can't fully parse: assume US (+1).
  const digits = raw.replace(/\D/g, '')
  if (digits.length === 10) return `+1${digits}`
  if (digits.length === 11 && digits.startsWith('1')) return `+${digits}`
  return ''
}

/**
 * Map a captured ContactCardPrefill onto the contact form's default values.
 * Returns only the person/company-domain fields — `company_name` is used
 * separately to seed the company search, not the form itself.
 */
export function buildContactPrefillDefaults(
  prefill?: ContactCardPrefill
): Partial<ContactDefaultValues> {
  if (!prefill) return {}
  return {
    first_name: prefill.first_name,
    last_name: prefill.last_name,
    title: prefill.title,
    email_work: prefill.email_work,
    email_personal: prefill.email_personal,
    phone_number: normalizePhoneToE164(prefill.phone_number),
    url: prefill.url,
    linkedin_url: prefill.linkedin_url,
    company_domain: prefill.company_domain,
  }
}
